export default __webpack_public_path__ + "static/media/icon-insights-item-description.0e7a6848.svg";